var brDirective = [
  "$animate",
  "$compile",
  function($animate, $compile) {
    return {
      restrict: "E",
      link: function(scope, element, attr) {
        if (window.isDownload) {
          return;
        }

        // <br style="page-break-before:always; clear: both;"><page-break></page-break>
        // <br style="page-break-before:always; clear: both; mso-break-type:section-break"><section-break></section-break>

        const domElement = element[0];
        const style = domElement.getAttribute("style");

        if (style) {
          
          if (domElement.nextElementSibling && domElement.nextElementSibling.tagName == "SECTION-BREAK") {
            domElement.setAttribute("data-custom-style", "mso-break-type: section-break;");
            pageLayersManager.setupSectionBreak(domElement);
            domElement.setAttribute("style", style + "; position: relative;");
          } else if (domElement.nextElementSibling && domElement.nextElementSibling.tagName == "PAGE-BREAK") {
            pageLayersManager.setupPageBreak(domElement);
            domElement.setAttribute("style", style + " position: relative;");
          }
        }
      }
    };
  }
];

angular.module("LeasePilot").directive("br", brDirective);
